<template>
  <div class="px-4">
    <v-form v-if="indexCustomer > -1">
      <validation-provider
        v-slot="{ errors }"
        name="Họ và tên"
        :vid="indexCustomer === 0 ? 'Họ và tên' : `Họ và tên ${indexCustomer +1}`"
        :rules="{required: !customer.isMainCustomer, max:255}"
      >
        <template v-if="(stateModule.typeId === moduleTypes.TU_HOC && stateModule.schoolLevelId === moduleSchoolLevel.TH && contactStatus === 'M')  && dataForm.isDetail">
          <v-text-field
              :disabled="customer.isMainCustomer"
              v-model="computedFullName"
              :label="indexCustomer === 0 ? 'Họ và tên' : `Họ và tên ${indexCustomer +1}`"
              color="primary"
              :error-messages="errors"
          />
        </template>
        <template v-else>
          <v-text-field
              :disabled="customer.isMainCustomer"
              v-model="customer.fullName"
              :label="indexCustomer === 0 ? 'Họ và tên' : `Họ và tên ${indexCustomer +1}`"
              color="primary"
              :error-messages="errors"
          />
        </template>

      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="Email"
        :vid="indexCustomer === 0 ? 'Email' : `Email ${indexCustomer +1}`"
        :rules="{ max:255, email: true, regex: regex.isEmail }"
      >
        <v-text-field
          v-model="customer.email"
          :label="indexCustomer === 0 ? 'Email' : `Email ${indexCustomer +1}`"
          :error-messages="errors"
          color="primary"
        />
      </validation-provider>
      <span>
        <label>Phụ huynh</label>
        <v-radio-group :disabled="customer.isMainCustomer" v-model="customer.position" row>
          <v-radio label="Bố" value="father" />
          <v-radio label="Mẹ" value="mother" />
          <v-radio label="Khác" value="other" />
        </v-radio-group>
      </span>
      <span>
        <label>SĐT</label>
         <template v-if="(stateModule.typeId === moduleTypes.TU_HOC && stateModule.schoolLevelId === moduleSchoolLevel.TH && contactStatus === 'M')  && dataForm.isDetail">
               <validation-provider
                   v-slot="{ errors }"
                   name="Điện thoại"
                   :rules="{ regex: '', required: true }"
                   :vid="indexCustomer === 0 ? 'Điện thoại' : `Điện thoại ${indexCustomer +1}`"
               >
          <v-text-field
              :disabled="customer.isMainCustomer"
              v-model="computedPhoneNumber"
              label="SĐT"
              color="primary"
              :error-messages="errors"
          >
            <template v-if="!customer.isMainCustomer" v-slot:append-outer>
              <v-btn
                  color="blue"
                  text
                  style="text-transform: inherit; font-weight: bold; font-size: 14px;"
                  @click="onClickDeleteMainPhone(customer)"
              >Xoá</v-btn>
            </template>
          </v-text-field>
        </validation-provider>
        </template>
        <template v-else>
               <validation-provider
                   v-slot="{ errors }"
                   name="Điện thoại"
                   :rules="{ regex: regex.isVNPhoneMobile, required: true }"
                   :vid="indexCustomer === 0 ? 'Điện thoại' : `Điện thoại ${indexCustomer +1}`"
               >
          <v-text-field
              :disabled="customer.isMainCustomer"
              v-model="customer.mobile"
              label="SĐT"
              color="primary"
              :error-messages="errors"
          >
            <template v-if="!customer.isMainCustomer" v-slot:append-outer>
              <v-btn
                  color="blue"
                  text
                  style="text-transform: inherit; font-weight: bold; font-size: 14px;"
                  @click="onClickDeleteMainPhone(customer)"
              >Xoá</v-btn>
            </template>
          </v-text-field>
        </validation-provider>
        </template>
         <template v-for="(phone, indexPhone) in customer.phones">
           <template v-if="(stateModule.typeId === moduleTypes.TU_HOC && stateModule.schoolLevelId === moduleSchoolLevel.TH && contactStatus === 'M')  && dataForm.isDetail">
              <v-text-field
                  :key="indexPhone + '_phone'"
                  :value="maskedPhoneNumber(phone)"
                  label="Số điện thoại phụ"
                  color="primary"
                  readonly
              >
                <template v-slot:append-outer>
                  <v-btn
                      color="blue"
                      text
                      style="text-transform: inherit; font-weight: bold; font-size: 14px;"
                      @click="onClickDeleteSubPhone(indexPhone, customer)"
                  >Xoá</v-btn>
                </template>
              </v-text-field>
            </template>
          <template v-else>
               <v-text-field
                   :key="indexPhone + '_phone'"
                   :value="phone"
                   label="Số điện thoại phụ"
                   color="primary"
                   readonly
                   type="number"
               >
                <template v-slot:append-outer>
                  <v-btn
                      color="blue"
                      text
                      style="text-transform: inherit; font-weight: bold; font-size: 14px;"
                      @click="onClickDeleteSubPhone(indexPhone, customer)"
                  >Xoá</v-btn>
                </template>
              </v-text-field>
          </template>
        </template>
        <validation-provider
          v-slot="{ errors }"
          :rules="{ regex: regex.isVNPhoneMobile }"
          name="Số điện thoại phụ"
          :vid="indexCustomer === 0 ? 'Số điện thoại phụ' : `Số điện thoại phụ ${indexCustomer +1}`"
        >
          <v-text-field
            v-model="customer.phoneSub"
            label="Số điện thoại phụ"
            :error-messages="errors"
          >
            <template v-slot:append-outer>
              <v-btn
                text
                style="text-transform: inherit; font-weight: bold; font-size: 14px;"
                @click="onClickAddSubPhone(customer)"
              >
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </validation-provider>
      </span>
      <template v-for="(contactColumn, indexContact) in contactColumnList">
        <v-text-field
          v-if="contactColumn.type === 'text'"
          :key="'indexContact_' + indexContact"
          v-model="customer[contactColumn.id]"
          :label="contactColumn.description"
          color="primary"
        />
        <v-textarea
          v-else-if="contactColumn.type === 'textarea'"
          :key="'indexContact_' + indexContact"
          v-model="customer[contactColumn.id]"
          :label="contactColumn.description"
          rows="2"
        />
      </template>
    </v-form>
    <v-card-actions v-show="showAddCustomer" style="text-align: right;">
      <v-btn color="success" @click="onClickAddParent">
        <v-icon>mdi-plus</v-icon>Thêm phụ huynh
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import {maskedPhoneNumber} from "@/helpers/regex";
import {regex, contactDetail, moduleTypes, moduleSchoolLevel} from '../../../helpers/constants';
export default {
  props: {
    contactColumns: {
      type: Object,
      default: () => ({}),
    },
    customer: {
      type: Object,
      default: () => {}
    },
    indexCustomer: {
      type: Number,
      default: -1
    },
    dataForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      regex,
    };
  },
  computed: {
    moduleSchoolLevel() {
      return moduleSchoolLevel
    },
    moduleTypes() {
      return moduleTypes
    },
    contactStatus() {
      return _.get(this.dataForm, 'contactStatus.type[0]', '');
    },
    computedFullName() {
      const module = this.$store.state.module;
      if (this.dataForm.customers[0].fullName === this.dataForm.customers[0].mobile) {
        if (module.typeId === moduleTypes.TU_HOC && module.schoolLevelId === moduleSchoolLevel.TH && this.contactStatus === 'M') {
          return maskedPhoneNumber(this.customer.fullName);
        }
        return this.customer.fullName;
      }
      return this.customer.fullName;
    },
    stateModule() {
      return this.$store.state.module
    },
    computedPhoneNumber() {
      const module = this.$store.state.module;
      if (module.typeId === moduleTypes.TU_HOC && module.schoolLevelId === moduleSchoolLevel.TH && this.contactStatus === 'M') {
        return maskedPhoneNumber(this.customer.mobile);
      }
      return this.customer.mobile;

    },
    contactColumnList() {
      return _.get(this.contactColumns, 'parent', []) || [];
    },
    showAddCustomer() {
      return (this.indexCustomer + 1) === this.customersLength && this.customersLength < 5;
    },
    customersLength() {
      return this.dataForm.customers.filter(
        customer => customer.position != 'child' &&
        !_.get(customer, 'isDeleted', false)
      ).length;
    }
  },
  methods: {
    maskedPhoneNumber,
    onClickRemoveCustomer(customerId) {
      this.$swal({
        title: 'Xóa thông tin của phụ huynh',
        text: 'Bạn có thực sự muốn xoá ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy bỏ'
      }).then(async result => {
        if (result.value) {
          const index = this.dataForm.customers.findIndex(
            customer => customer.customerId === customerId
          );
          if (index === -1) {
            return;
          }
          const customerTemp = this.dataForm.customers[index];
          customerTemp.isDeleted = true;
          this.dataForm.customers.splice(index, 1);
          if (this.$route.params.id && !_.get(customerTemp, 'isNew', true)) {
            this.dataForm.customers.push(customerTemp);
          }
        }
      });
    },
    onClickAddParent() {
      if (this.customersLength === contactDetail.MAX_CONTACT) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Bạn chỉ có thể tạo tối đa 5 thông tin phụ huynh',
        });
      }
      this.dataForm.customers.push({
        customerId: new Date().getTime(),
        phones: [],
        isMainCustomer: false,
        position: 'other'
      });
    },
    onClickDeleteMainPhone(customer) {
      const customerTemp = customer;
      customerTemp.mobile = '';
    },
    onClickAddSubPhone(customer) {
      const customerTemp = customer;
      if (this.regex.isVNPhoneMobile.exec(customerTemp.phoneSub)) {
        if(customer.phoneSub === customer.mobile) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Số điện thoại phụ không được giống số điện thoại chính',
          });
        }
        customerTemp.phones.push(customer.phoneSub || '');
        customerTemp.phoneSub = '';
      }
    },
    onClickDeleteSubPhone(indexPhone, customer) {
      const customerTemp = customer;
      customerTemp.phones.splice(indexPhone, 1);
    }
  }
};
</script>
